import React from 'react'

const Mastercard = () => {
  return (
    <div className="icon--mastercard">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="10"
        viewBox="0 0 9 10"
        fill="none"
      >
        <path
          d="M8.11 1.08C7.39645 0.591698 6.56314 0.307423 5.69993 0.257822C4.83672 0.208222 3.97634 0.395178 3.21155 0.798534C2.44676 1.20189 1.80658 1.80635 1.36001 2.54674C0.913448 3.28713 0.677444 4.13536 0.677444 5C0.677444 5.86464 0.913448 6.71288 1.36001 7.45326C1.80658 8.19365 2.44676 8.79811 3.21155 9.20147C3.97634 9.60482 4.83672 9.79178 5.69993 9.74218C6.56314 9.69258 7.39645 9.4083 8.11 8.92C7.15592 7.83703 6.62955 6.44329 6.62955 5C6.62955 3.55671 7.15592 2.16297 8.11 1.08Z"
          fill="currentColor"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="10"
        viewBox="0 0 11 10"
        fill="none"
      >
        <path
          d="M5.56 9.75C8.18335 9.75 10.31 7.62335 10.31 5C10.31 2.37665 8.18335 0.25 5.56 0.25C2.93665 0.25 0.809998 2.37665 0.809998 5C0.809998 7.62335 2.93665 9.75 5.56 9.75Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default Mastercard
